var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__caret--wide--system icon--style--fill icon--size--large",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M22.944 7.669A1 1 0 0022 7H2a1 1 0 00-.625 1.781l10 8a1 1 0 001.25 0l10-8a1 1 0 00.319-1.112z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }